module.exports = __webpack_public_path__ + "static/media/vehicle_in_out_2.a535b0cb.png";